
export const toCamelCase = (string) => {
  const splittedString = string.split('-');
  const capitalizedSubstrings = splittedString.map((item, index) => index
    ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
    : item.toLowerCase());
  return capitalizedSubstrings.join('');
}
